// Security features: copy/paste, right-click, focus/tab switch
import React, { useEffect, useState } from 'react';

const SecurityLayer = () => {
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener('contextmenu', handleContextMenu);

    // Disable copy/paste
    const handleCopyPaste = (e) => e.preventDefault();
    document.addEventListener('copy', handleCopyPaste);
    document.addEventListener('cut', handleCopyPaste);
    document.addEventListener('paste', handleCopyPaste);

    // Warn on tab/window switch
    const handleBlur = () => setShowWarning(true);
    const handleFocus = () => setShowWarning(false);
    window.addEventListener('blur', handleBlur);
    window.addEventListener('focus', handleFocus);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('copy', handleCopyPaste);
      document.removeEventListener('cut', handleCopyPaste);
      document.removeEventListener('paste', handleCopyPaste);
      window.removeEventListener('blur', handleBlur);
      window.removeEventListener('focus', handleFocus);
    };
  }, []);

  return showWarning ? (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: '#dc2626cc', color: '#fff', zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, fontWeight: 700 }}>
      Warning: Please do not switch tabs or windows during the exam!
    </div>
  ) : null;
};

export default SecurityLayer;
